// Importing Foundation first
// ### Core
import $ from 'jquery';
// All Foundation modules
// import Foundation from 'foundation-sites'
// Custom selected Foundation modules
import './foundation';
import 'what-input';

$(window).on('load', () => {
  $(document).foundation();
});


// Import all your components here
// But don't code inside this file.
import './polyfill';
import './utils';

// Components
import './components/gallery-media';
import './components/loader';
import './components/mobile-menu';
import './components/slider-events';
import './components/slider-event-nav';
import './components/slider-event-program';
import './components/slider-footer-partners';
import './components/slider-ranking';
import './components/slider-news';
import './components/slider-riders';
import './components/slider-videos';
import './components/smooth-scroll';
import './components/social-share';
// import './components/photoswipe';
// import './components/swiper';

// Enables HMR for JS files imported here
if (module.hot) {
  module.hot.accept();
}
